"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var SortButton_1 = __importDefault(require("../widgets/SortPanel/SortButton"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        filterPanel: (_a = {
                padding: theme.spacing(1.5)
            },
            _a[theme.breakpoints.up('md')] = {
                width: 300,
            },
            _a),
        headerText: {
            padding: theme.spacing(3.5),
        },
    });
});
/**
 * @component Filter dropdown that filters the search by the given labels.
 */
var FilterDrawer = function (_a) {
    var labels = _a.labels, selectedLabel = _a.selectedLabel, onClick = _a.onClick, isFilterOpen = _a.isFilterOpen, isMobileView = _a.isMobileView, setIsFilterOpen = _a.setIsFilterOpen;
    var classes = useStyles();
    var handleDrawerClose = function () {
        setIsFilterOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isMobileView ? (react_1.default.createElement(core_1.Drawer, { anchor: "bottom", open: isFilterOpen, onBackdropClick: handleDrawerClose, onEscapeKeyDown: handleDrawerClose },
        react_1.default.createElement(core_1.Collapse, { in: isFilterOpen },
            react_1.default.createElement(core_1.Paper, { className: classes.filterPanel },
                react_1.default.createElement(core_1.Typography, { variant: "h4", className: classes.headerText }, "Search by"),
                react_1.default.createElement(core_1.Divider, null),
                react_1.default.createElement(core_1.Grid, null, labels.map(function (label) { return (react_1.default.createElement(SortButton_1.default, { onClick: function () {
                        onClick(label);
                        setIsFilterOpen(false);
                    }, key: label, columnLabel: label, isSelected: label === selectedLabel })); })))))) : (react_1.default.createElement(core_1.Collapse, { in: isFilterOpen },
        react_1.default.createElement(core_1.Paper, { className: classes.filterPanel },
            react_1.default.createElement(core_1.Grid, null, labels.map(function (label) { return (react_1.default.createElement(SortButton_1.default, { onClick: function () {
                    onClick(label);
                    setIsFilterOpen(false);
                }, key: label, columnLabel: "Search by ".concat(label), isSelected: label === selectedLabel })); })))))));
};
exports.default = FilterDrawer;
